var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.102 4.522L4.712.375v7.598L.851 5.47v22.005l6.392 4.147v-7.602l3.858 2.506V4.522z",
    fill: "#60F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.711.375v7.598l2.533 1.645V24.02l3.858 2.506V4.522L4.712.375z",
    fill: "url(#logo_svg__paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.853 5.47v22.006l6.39 4.147V24.02l-2.532-1.64V7.972L.853 5.47z",
    fill: "url(#logo_svg__paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__paint0_linear",
    x1: 2.402,
    y1: 14.695,
    x2: 15.421,
    y2: 17.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#6E06F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#8216DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A331B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#D0557A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__paint1_linear",
    x1: -3.867,
    y1: 19.844,
    x2: 8.946,
    y2: 22.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#15B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2A85FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#444CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#5623FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#6209FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60F"
  })))));
}
export default SvgLogo;